import {useDebugValue} from 'react';

import classNames from 'classnames';

const classNamespace = 'search-form';

const dayClassName = `${classNamespace}__day`;
const dayContentClassName = `${dayClassName}-content`;
const dayLabelClassName = `${dayClassName}-label`;
const dayValueClassName = `${dayClassName}-value`;

const standardDayClassName = `${classNamespace}__standard-day`;

const hiddenClassName = 'hidden';

const dateClassName = 'date';
const pastClassName = 'past';
const todayClassName = 'today';

function useComponent(props) {
    const {
        ariaLabelDate,
        day,
        isPast,
        isToday
    } = props;

    const className = classNames(dayClassName, standardDayClassName);

    const contentClassName = classNames(dayContentClassName);

    const labelClassName = classNames(dayLabelClassName, dateClassName, {
        [pastClassName]: isPast,
        [todayClassName]: isToday
    });

    const valueClassName = classNames(dayValueClassName, hiddenClassName);

    const result = {
        className,
        contentClassName,
        labelClassName,
        valueClassName,
        day,
        ariaLabelDate
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
